import '../scss/main.scss';

import form from './components/form';

jQuery(document).ready(function () {
    form(jQuery);
});